import { BaseSettingsScreen } from '../screen/BaseSettingsScreen';

export class OthersEntity extends BaseSettingsScreen {
  readonly type = 'others';
}
